import Tire from './tire';
import { CarCenter } from './car-center';
import { Tire as TireModel } from '../models/tire';
import { TirePosition } from '../models/tire-position.ts';
import { TireConfig } from "../models/report.ts";
import { TireImagePosition } from "../models/enums/tire-image-position.enum.ts";

type CarProps = {
    tires: Partial<TireModel>[];
    config?: TireConfig;
    refDate?: Date | null;
};

const Car = ({tires, config, refDate}: CarProps) => {
    const frontLeft = tires.find(t => t.position === TirePosition.FRONT_LEFT);
    const frontRight = tires.find(t => t.position === TirePosition.FRONT_RIGHT);
    const rearLeft = tires.find(t => t.position === TirePosition.REAR_LEFT);
    const rearRight = tires.find(t => t.position === TirePosition.REAR_RIGHT);

    return (
        <div className="grid grid-cols-3 grid-rows-2 gap-6 w-full h-full">
            <div className="flex">
                {frontLeft && <Tire tire={frontLeft} config={config} refDate={refDate} />}
            </div>
            <CarCenter />
            <div className="flex">
                {frontRight && <Tire tire={frontRight} position={TireImagePosition.LEFT} config={config} refDate={refDate} />}
            </div>
            <div className="flex">
                {rearLeft && <Tire tire={rearLeft} config={config} refDate={refDate} />}
            </div>
            <div className="flex">
                {rearRight && <Tire tire={rearRight} position={TireImagePosition.LEFT} config={config} refDate={refDate} />}
            </div>
        </div>
    );
};

export default Car;
